define([
	"dojo/_base/array",
	"dojo/_base/lang",
	"dojo/topic",
	"csi/def/Action",
	"csi/def/Request",
	"csi/def/ViewRef",
	"csi/locale",
	"csi/reflection",
	"csi/table/View",
	"csi/xml",
	"./util",
	"./TriggerExportManuallyAction"
], function(array,lang,topic,Action,Request,ViewRef,locale,reflection,TableView,xml,util) {

	topic.subscribe("/csi/toolbar/menu", function(obj) {
		// summary: add additional menu items to Export menu of the table.
		// Do a separate menu item for each ExportBatch suitable for the node type displayed in the table
		if (obj.name != "Export")
			return;

		var ctx = obj.ctx;

		// do not add Export-s to printable or popup views
		if (ctx.bPrint || (ctx.fd && !ctx.fd.m_bEditable))
			return;

		// make sure it's a table view
		if (!(ctx.defView instanceof TableView))
			return;

		// try to understand what is the target type of the table we are attaching to
		var targetType = ctx.defView.getPageClass();
		if (!targetType)
			return;

		// check the access
		if (!util.isCurrentUserAllowedToExport())
			return;

		// get the export batches configured for this type
		var exportBatches = util.getManuallyTriggeredBatchesForType(targetType,ctx.cache);
		var path = null;

		// if there are not batches and we are trying to export Master, try Revision
		if (!exportBatches) {
			var rc = reflection.getClass(targetType);
			if (rc.isMaster()) {
				var rcRevision = rc.getRevisionClass();
				var typeRevision = rcRevision.getType();
				exportBatches = util.getManuallyTriggeredBatchesForType(typeRevision,ctx.cache);
				path = xml.pathCreate(xml.PATH_OP_CHILD,reflection.ATTR_CURRENT_REVISION);
			}
		}

		// nothing to export, return
		if (!exportBatches)
			return;

		// now add menu items
		var viewId = ctx.defView.m_id;
		var plugins = obj.children;

		plugins.push("|");

		array.forEach(exportBatches, function(batch) {
			// reference the same view as used in the main table
			var	action = lang.mixin(new Action(), {
				m_id: "ExportListOfNodes",
				m_name: locale.resource(batch.$Name),
				m_viewRef: lang.mixin(new ViewRef(),{m_id:viewId, m_typeView:"Table"}),
				classController: "Export.ExportBatchController",
				m_request: lang.mixin(new Request(),{m_module:"Export",m_operation:"ExportBatch"}),
				bOneRequest: true,
				urlBatch: batch.$URL,	// pass the batch URL to the controller
				exportPath: path
			});
			action.resolve();

			plugins.push(action);
		});
	});

	return {
		VIEW: "__Export__"
	};
});